<template>
    <div class="shop-login">
        <div class="shop-login__body">
            <slot></slot>
        </div>
        <div class="button-wrapper v-center left spaced spacer--top">
            <template v-for="button in buttons">
                <a class="button button--primary" :href="button.link" v-html="button.label"></a>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shop-login",
        props: {
            buttons: Array
        },
    }
</script>
